<template>
  <ModuleContainer v-bind="bindModule">
    <div style="width: 100%" class="d-flex justify-center">
      <v-btn v-show="loading" loading fab small></v-btn>
    </div>
    <template #btn>
      <MapControlButton
        v-if="!readonly || isMobile"
        icon="mdi-layers"
        :tooltip="title"
        @click="onToggleShow"
      />
    </template>
    <template #draggable>
      <DraggableFloat
        :show.sync="c_show"
        :title="title"
        v-if="readonly"
        :bottom="10"
        :left="10"
        disabled-close
      >
        <template #title>
          <div class="d-flex justify-space-between" style="width: 100%;">
            <div style="font-size: 16px; font-weight: 600; color: #748190;">
              {{ title }}
            </div>
            <div @click="showAllLabel()" class="pl-4" v-if="map">
              <v-switch v-model="isShowAllLabel" hide-details>
                <template v-slot:label>
                  <div style="font-size: 13px; font-weight: bold;" class="pr-1"
                    >Bật nhãn</div
                  >
                </template></v-switch
              >
            </div>
          </div>
        </template>
        <div class="d-flex flex-column full-height">
          <div class="flex-grow-0">
            <slot name="extra-first" :mapId="mapId" />
          </div>
          <div class="flex-grow-1 overflow-auto">
            <LayerListControl
              ref="layers"
              :readonly="readonly"
              :settings="settings"
              :layers.sync="layers"
              @click:add-layer="onAddLayer"
              @click:add-layer-group="onAddLayerGroup"
              @update:layers="onUpdateListLayers"
              :layerIdSelect="layerIdSelect"
              :layerGroupIdSelect="layerGroupIdSelect"
              :selected.sync="layerSelection"
            >
              <template #extra-btn-item-group="{ group }">
                <base-button
                  class="mr-2"
                  icon
                  small
                  :tooltip="
                    group.show_layer_map ? 'Ẩn lớp bản đồ' : 'Hiển lớp bản đồ'
                  "
                  @click.stop="toggleGroupShow(group)"
                >
                  <v-icon v-if="group.show_layer_map" small>mdi-eye</v-icon>
                  <v-icon v-else small>mdi-eye-off</v-icon>
                </base-button>
              </template>
              <template #item="{ item, toggleSelect }">
                <div @click="toggleSelect(item)">
                  <LayerItem
                    class="pr-2"
                    :readonly="readonly"
                    :item="item"
                    @update:item="onUpdateLayer"
                    @click:bounds="onToBounds"
                    @click:remove="onRemoveLayer"
                    @click:action="onLayerAction"
                  >
                    <template #extra-btn> </template>
                  </LayerItem>
                </div>
              </template>
            </LayerListControl>
          </div>
          <div class="flex-grow-0">
            <slot name="extra-last" :mapId="mapId" />
          </div>
        </div>
      </DraggableFloat>
      <DraggableSidebar :show.sync="c_show" :title="title" v-else>
        <template #title>
          <div style="font-size: 16px; font-weight: 600; color: #748190;">
            {{ title }}
          </div>
        </template>
        <template #extra-btn>
          <base-button
            icon
            small
            v-if="!readonly"
            :disabled="!layerSelection || layerSelection.length < 1"
            @click="onAddGroup()"
            :tooltip="
              !layerSelection || layerSelection.length < 1
                ? 'Cần chọn lớp trước để nhóm'
                : 'Nhóm các lớp đang chọn'
            "
          >
            <v-icon>
              mdi-group
            </v-icon>
          </base-button>
          <base-button
            icon
            small
            type-action="delete"
            v-if="!readonly"
            :disabled="!layers || layers.length < 1"
            @click="onDeleteAllLayer()"
          >
          </base-button>
          <base-button
            icon
            small
            color="gray"
            type-action="create"
            v-if="!isNotCanUseLayerControl && !readonly"
            @click="onShowAddNewLayer"
          >
          </base-button>
          <base-button
            small
            class="text-none"
            icon
            use-tooltip
            color="error"
            v-if="isGlobalWMSOff && wkCanUse.length > 0"
          >
            <v-icon>mdi-information-outline</v-icon>
            <template #tooltip>
              <span>
                Dịch vụ wms tổng đang tắt, chỉ có thể xem trước các
                {{ $t('sidebar.workspace.name') }} có bật dịch vụ wms
              </span>
            </template>
          </base-button>
          <base-button
            small
            class="text-none"
            icon
            use-tooltip
            color="error"
            v-else-if="wkDisable.length > 0"
          >
            <v-icon>mdi-information-outline</v-icon>
            <template #tooltip>
              <span>
                Không thể xem được một số
                {{ $t('sidebar.workspace.name') }} do đã tắt dịch vụ wms
              </span>
            </template>
          </base-button>
        </template>
        <div class="full-height">
          <div class="d-flex flex-column full-height">
            <div class="flex-grow-1 overflow-hidden">
              <LayerListControl
                ref="layers"
                :readonly="readonly"
                :settings="settings"
                :layers.sync="layers"
                @click:add-layer="onAddLayer"
                @click:add-layer-group="onAddLayerGroup"
                @update:layers="onUpdateListLayers"
                :layerIdSelect="layerIdSelect"
                :layerGroupIdSelect="layerGroupIdSelect"
                :selected.sync="layerSelection"
              >
                <template #item="{ item, toggleSelect }">
                  <div @click="toggleSelect(item)">
                    <LayerItem
                      :readonly="readonly"
                      :item="item"
                      @update:item="onUpdateLayer"
                      @click:bounds="onToBounds"
                      @click:remove="onRemoveLayer"
                      @click:action="onLayerAction"
                    >
                      <template #extra-btn> </template>
                    </LayerItem>
                  </div>
                </template>
              </LayerListControl>
            </div>
            <div class="flex-grow-0">
              <slot name="extra-last" :mapId="mapId" />
            </div>
          </div>
        </div>
      </DraggableSidebar>

      <DraggablePopup
        :height="450"
        :is-resizable="false"
        :show.sync="style.show"
        title="Nội dung trình bày"
        :width="450"
        :top="10"
        :left="410"
        @close="onCloseStyle"
      >
        <preview-simple-edit
          v-if="style.show"
          v-model="style.data.content"
          :fields="style.fields"
        ></preview-simple-edit>
        <template #footer>
          <div class="d-flex pa-2">
            <v-spacer></v-spacer>

            <base-button color="primary" text @click="onSaveStyle()">
              Áp dụng
            </base-button>
          </div>
        </template>
      </DraggablePopup>
      <DraggablePopup
        :height="450"
        :is-resizable="false"
        :show.sync="popup_filter_data.show"
        title="Nội dung hiển thị dữ liệu"
        :width="450"
        :top="10"
        :left="410"
        @close="closeFilterDataControl"
      >
        <preview-filter-data-edit
          v-if="popup_filter_data.show"
          v-model="popup_filter_data.data"
          :fields="popup_filter_data.fields"
          :layer="popup_filter_data.layer"
        ></preview-filter-data-edit>
        <template #footer>
          <div class="d-flex pa-2">
            <v-spacer></v-spacer>

            <base-button color="primary" text @click="onSaveFilterData()">
              Áp dụng
            </base-button>
          </div>
        </template>
      </DraggablePopup>
      <DraggablePopup
        :height="450"
        :is-resizable="false"
        :show.sync="style_label.show"
        title="Nội dung nhãn"
        :width="450"
        :top="10"
        :left="410"
        @close="closeStyleLabelControl"
      >
        <preview-simple-label-edit
          v-if="style_label.show"
          v-model="style_label.data.content_label"
          :metadata.sync="style_label.data.metadata"
          :fields="style_label.fields"
          :layer="style_label.layer"
        ></preview-simple-label-edit>
        <template #footer>
          <div class="d-flex pa-2">
            <v-spacer></v-spacer>

            <base-button color="primary" text @click="onSaveLabelStyle()">
              Áp dụng
            </base-button>
          </div>
        </template>
      </DraggablePopup>
    </template>
    <LayerTableControl
      v-if="table.show && table.data"
      :show.sync="table.show"
      :layer="table.data"
    />
    <slot :layers="layers"></slot>
  </ModuleContainer>
</template>

<script>
import { Marker } from 'mapbox-gl'

import { API_LAYER, API_STYLE } from '@/src/service/api/modules'
import {
  DraggableFloat,
  DraggablePopup,
  DraggableSidebar,
} from '@components/draggable'
import LayerItem from '@components/layer/layer-item.vue'
import MapControlButton from '@components/Map/control/MapControlButton.vue'
import ModuleMixin from '@components/Map/mixins/ModuleMixin'
import PlaceholderModuleLayerMixin from '@components/Map/mixins/PlaceholderModuleLayerMixin'
import { center } from '@turf/turf'
import PreviewSimpleEdit from '@views/styles/preview/edit-simple.vue'
import PreviewSimpleLabelEdit from '@views/styles/preview/edit-label-simple.vue'
import PreviewFilterDataEdit from '@views/styles/preview/edit-filter-data-simple.vue'

import LayerListControl from './layer-list-control.vue'
import {
  createLayer,
  getLayerData,
  removeLayer,
  updateLayerSimple,
  updateLayerStyle,
} from './model/layer'
import { LAYER_ACTION_TYPE, setActionSupport } from './model/view'

const DEFAULT_COLOR_HIGHLIGHT = '#004E98'

export default {
  components: {
    LayerListControl,
    MapControlButton,
    DraggableSidebar,
    DraggablePopup,
    PreviewSimpleEdit,
    LayerItem,
    LayerTableControl: () => import('./LayerTableControl.vue'),
    DraggableFloat,
    PreviewSimpleLabelEdit,
    PreviewFilterDataEdit,
  },
  mixins: [ModuleMixin, PlaceholderModuleLayerMixin],
  props: {
    settings: {},
    value: { type: Array, default: () => [], requred: true },
    title: { type: String, default: 'Quản lý lớp bản đồ' },
    show: Boolean,
    readonly: Boolean,
    headless: Boolean,
  },
  data: (vm) => ({
    p_show: true,
    layers: [],
    style: { show: false, data: null, fields: [], component: null },
    style_label: { show: false, data: null, fields: [], component: null },
    popup_filter_data: { show: false, data: null, fields: [] },
    table: { show: false, data: null, component: null },
    detail: { show: false, data: null, component: null },
    layerIdSelect: [],
    layerGroupIdSelect: [],
    layerInfo: null,
    loading: false,
    layerSelection: [],
    isShowAllLabel: false,
  }),
  computed: {
    isGlobalWMSOff() {
      return (
        this.settings &&
        this.settings.data &&
        !this.settings.data.is_global_enable
      )
    },
    wkCanUse() {
      return this.settings.data.workspaces_enabled
    },
    wkDisable() {
      return this.settings.data.workspaces_disabled
    },
    isNotCanUseLayerControl() {
      return this.isGlobalWMSOff && (!this.wkCanUse || this.wkCanUse.length < 1)
    },
    c_show: {
      get() {
        return this.p_show
      },
      set(value) {
        this.p_show = value
      },
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val !== undefined) this.p_show = val
      },
    },
    p_show(val) {
      this.$emit('update:show', val)
    },
    layers: {
      deep: true,
      handler(val) {
        this.$emit('update:layers', val)
      },
    },
  },

  methods: {
    onInit() {
      let vm = this
      setActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE, (layer) =>
        vm.showStyleControl(layer)
      )
      setActionSupport(LAYER_ACTION_TYPE.SHOW_STYLE_LABEL, (layer) =>
        vm.showStyleLabelControl(layer)
      )
      setActionSupport(LAYER_ACTION_TYPE.SHOW_FILTER_DATA, (layer) =>
        vm.showFilterDataControl(layer)
      )
      setActionSupport(LAYER_ACTION_TYPE.SHOW_TABLE, (layer) =>
        vm.showTableControl(layer)
      )
      setActionSupport(LAYER_ACTION_TYPE.SHOW_DETAIL, (layer) => {
        vm.showDetailControl(layer)
      })
      setActionSupport(LAYER_ACTION_TYPE.SHOW_LABEL, (layer, show) => {
        if (!this.map) return
        let temp = getLayerData(layer)
        temp.showLabel(this.map, show)
      })

      this.$root.$on('layer-control:hightlight-layer', (res) => {
        if (!this.map) return
        this.removeMarker()
        if (this.map.getLayer('highlight')) this.map.removeLayer('highlight')
        if (this.map.getSource('highlight')) this.map.removeSource('highlight')
        if (res.features[0]?.geometry?.type?.includes('Point')) {
          this.marker = new Marker({ color: DEFAULT_COLOR_HIGHLIGHT })
            .setLngLat(res.features[0]?.geometry?.coordinates)
            .addTo(this.map)
        } else {
          const geojson = res
          this.map.addSource('highlight', { type: 'geojson', data: geojson })
          const highlight = {
            id: 'highlight',
            type: 'line',
            source: 'highlight',
            paint: {
              'line-color': DEFAULT_COLOR_HIGHLIGHT,
              'line-width': 2,
            },
          }
          this.map.addLayer(highlight)
          if (res.features[0]?.geometry?.type?.includes('Polygon')) {
            const markCenter = center(res.features[0]?.geometry)
            this.marker = new Marker({})
              .setLngLat(markCenter?.geometry?.coordinates)
              .addTo(this.map)
          }
        }
      })
    },
    showAllLabel(show) {
      if (show != null) {
        this.isShowAllLabel = show
      }
      this.layers.forEach((layer) => {
        let temp = getLayerData(layer)
        let menu = layer.menus.find((x) => x.id == LAYER_ACTION_TYPE.SHOW_LABEL)
        layer.show_label = this.isShowAllLabel
        if (menu) menu.text = layer.show_label ? 'Tắt nhãn' : 'Bật nhãn'
        temp.showLabel(this.map, this.isShowAllLabel)
      })
    },
    onUpdateLayer(layer) {
      updateLayerSimple(this.map, layer)
    },
    onUpdateLayerStyle(layer) {
      updateLayerStyle(this.map, layer)
    },
    onToBounds(layer) {
      let temp = getLayerData(layer)
      if (!temp) return
      temp.flyTo(this.map)
    },
    onLayerAction({ menu, item }) {
      if (menu && menu.click) menu.click(item, this.map, menu)
    },
    onShowAddNewLayer() {
      if (this.$refs.layers) {
        this.$refs.layers.onShowAddNewLayer()
      }
    },
    onRemoveLayer(layer) {
      this.removeLayer(layer)
      let index = this.layers.findIndex((x) => x.id == layer.id)
      if (index < 0) {
        return
      }
      this.layers.splice(index, 1)
    },
    onCloseStyle() {
      this.style = { show: false, data: null, fields: [] }
    },
    onAddLayer({ layers = [] } = {}) {
      let temps = layers.reverse().reduce((acc, cur) => {
        if (this.layerIdSelect.includes(cur.info.id)) {
          return
        }
        this.layerIdSelect.push(cur.info.id)
        acc.push(this.createLayer(cur))
        return acc
      }, [])
      this.layers.unshift(...temps.reverse())
    },
    createLayer(layer) {
      let res = createLayer(this.map, layer, this.readonly)

      let temp = getLayerData(layer)
      if (temp && temp.setClick)
        temp.setClick(this.map, (feature) => {
          this.$emit('click:select-feature', feature)
        })
      return res
    },

    onAddLayerGroup({ layerGroups = [], styles = [] } = {}) {},
    onToggleShow() {
      this.p_show = !this.p_show
    },
    onUpdateListLayers(layers) {
      let beforeId = this.placeholderModuleLayerId
      layers.forEach((layer) => {
        let temp = getLayerData(layer)
        temp.moveLayer(this.map, beforeId)
        beforeId = temp.getBeforeId()
      })
    },
    async onSaveStyle() {
      let temp = getLayerData(this.style.layer)
      if (!temp) return
      API_STYLE.create(this.style.data)
      temp.setStyle(this.map, this.style.data)
      this.$nextTick(() => {
        this.onUpdateListLayers(this.layers)
      })
    },
    onDeleteAllLayer() {
      if (!this.layers || this.layers.length < 1 || !this.map) {
        return
      }
      this.layers.forEach((layer) => {
        if (!layer.disable_delete) removeLayer(this.map, layer)
      })
      this.layers = []
      this.layerGroupIdSelect = []
      this.layerIdSelect = []
    },
    removeLayer(layer) {
      layer.selected = false
      if (this.style.show && this.style.data.id == layer.id) {
        this.closeStyle()
      }
      if (this.table.show && this.table.data.id == layer.id) {
        this.closeTable()
      }
      if (this.detail.show && this.detail.data.id == layer.id) {
        this.closeDetailControl()
      }
      this.layerIdSelect = this.layerIdSelect.filter((x) => x != layer.info.id)
      removeLayer(this.map, layer)
    },
    showStyleControl(layer) {
      this.style.show = true
      this.style.layer = layer
      this.style.data = layer.info.style
      this.style.fields = layer.metadata.fields
    },
    showStyleLabelControl(layer) {
      this.style_label.show = true
      this.style_label.layer = layer
      this.style_label.data = layer.info.style
      this.style_label.fields = layer.metadata.fields
    },
    closeStyleLabelControl() {
      this.style_label.show = false
      this.style_label.data = null
    },
    showFilterDataControl(layer) {
      this.popup_filter_data.show = true
      this.popup_filter_data.layer = layer
      this.popup_filter_data.data = layer.info.content_filter
      this.popup_filter_data.fields = layer.metadata.fields
    },
    closeFilterDataControl() {
      this.popup_filter_data.show = false
      this.popup_filter_data.data = null
    },
    onSaveLabelStyle() {
      let temp = getLayerData(this.style_label.layer)
      if (!temp) return
      API_STYLE.create(this.style_label.data)
      temp.setLabelStyle(this.map, this.style_label.data)
      this.$nextTick(() => {
        this.onUpdateListLayers(this.layers)
      })
    },
    async onSaveFilterData() {
      let layerView = this.popup_filter_data.layer
      let temp = getLayerData(layerView)
      if (!temp) return
      const layerInfo = layerView.info
      const res = await API_LAYER.updateDetail(layerInfo.id, {
        name: layerInfo.name,
        content_filter: this.popup_filter_data.data,
      })
      const updated = res && (res.data || res)
      layerInfo.content_filter = this.popup_filter_data.data
      if (updated && updated.bounds) {
        layerInfo.bounds = updated.bounds
        layerInfo.minx = updated.minx
        layerInfo.miny = updated.miny
        layerInfo.maxx = updated.maxx
        layerInfo.maxy = updated.maxy
        if (layerView.metadata) {
          this.$set(layerView.metadata, 'bounds', updated.bounds)
        }
        if (temp.info) {
          temp.info.bounds = updated.bounds
          temp.info.minx = updated.minx
          temp.info.miny = updated.miny
          temp.info.maxx = updated.maxx
          temp.info.maxy = updated.maxy
          temp.info.content_filter = this.popup_filter_data.data
        }
        if (temp.layer && temp.layer.metadata) {
          this.$set(temp.layer.metadata, 'bounds', updated.bounds)
        }
        if (temp.source) {
          temp.source.bounds = updated.bounds
        }
      }
      if (temp.resetSource) {
        temp.resetSource(this.map)
      }
      this.$nextTick(() => {
        this.onUpdateListLayers(this.layers)
        if (temp.flyTo) {
          temp.flyTo(this.map)
        }
      })
    },
    closeStyle() {
      this.style.show = false
      this.style.data = null
    },
    showTableControl(layer) {
      this.table.show = false
      this.$nextTick(() => {
        this.table.show = true
        this.table.data = layer
        this.table.layer = layer.info
      })
    },
    closeTable() {
      this.table.show = false
      this.table.layer = null
      this.table.data = null
    },
    showDetailControl(layer) {
      this.detail.show = false
      this.$nextTick(() => {
        this.detail.show = true
        this.detail.data = layer
        this.detail.layer = layer.info
      })
    },
    closeDetailControl() {
      this.detail.show = false
      this.detail.layer = null
      this.detail.data = null
    },
    getLayers() {
      return this.layers.map((layer) => {
        return {
          layer_type: layer.type,
          data_type: layer.data_type,
          info: { id: layer.info.id },
          group: layer.group,
        }
      })
    },
    onAddGroup() {
      this.$refs.layers.addNewGroup()
    },
    toggleGroupShow(group) {
      group.show_layer_map = !group.show_layer_map
      group.children.forEach((layer) => {
        let temp = getLayerData(layer)
        if (!temp) return
        layer.show = group.show_layer_map
        temp.toggleShow(this.map, layer.show)
      })
    },
    removeMarker() {
      if (this.marker) {
        this.marker.remove()
      }
      this.marker = null
    },
  },
}
</script>
<style>
.mapboxgl-popup-close-button {
  display: none;
}

.mapboxgl-popup-content {
  max-width: 400px;
  min-width: 300px;
}
</style>
